// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608190454/js/" + chunkId + "." + {"44":"098a0ce7","225":"c2af8eca","481":"8bb77802","486":"621741f3","770":"8ac8cd56"}[chunkId] + ".0.11743155841199537.chunk.js";
};